import { render, staticRenderFns } from "./NationalTrademarkSearchHistoryList.vue?vue&type=template&id=fd5210e6&"
import script from "./NationalTrademarkSearchHistoryList.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkSearchHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkSearchHistoryList.vue?vue&type=style&index=0&id=fd5210e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports